import { emailTemplateSettingsService } from '../services'
import router from '../router'

const state = {
    loading: false,
    settings: {
        loading: false,
        data: {}
    }
}

const actions = {

    loadSettings ({ dispatch, commit }, params) {
        commit('getSettingsRequest')
        emailTemplateSettingsService.loadSettings(params).then(
            response => {
                commit('getSettingsSuccess', response)
            }
        )
    },

    saveSettings({ dispatch, commit }, params) {
        commit('startRequest')
        emailTemplateSettingsService.saveSettings(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Email Template Settings updated successfully', { root: true })

                emailTemplateSettingsService.loadSettings(params).then(
                    response => {
                        commit('getSettingsSuccess', response)
                    }
                )
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to update email template settings: ' + error, { root: true })
            }
        )
    },
}

const mutations = {
    getSettingsRequest (state) {
        state.loading = true
        state.settings = { loading: true, data: {} }
    },
    getSettingsSuccess (state, data) {
        state.loading = false
        state.settings = { loading: false, data: data.settings }
    },
    startRequest (state) {
        state.settings.loading = true
    },
    endRequest (state) {
        state.settings.loading = false
    },
}

const getters = {
    getSettings (state) {
        return state.settings.data
    },
    isBusy (state) {
        return state.settings.loading === true
    },
    isInitialBusy (state) {
        return state.loading === true
    }
}

export const emailTemplateSettingsModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
